import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Field, FieldRenderProps } from 'react-final-form';
import { IResetPasswordInputs } from '../../models/dtoAuthTypes';
import { resetPasswordCall } from '../../api/authService';
import { validateResetPasswordForm } from '../forms/Validation';
import TextInput from '../forms/TextInput';
import { saveVisit } from '../../api/visitTrackerService';

const ResetPassword = () => {
    const { ResetCode } = useParams();
    const ResetCodeValid = ResetCode !== undefined && ResetCode.length === 16;
    const [errorConnection, setError] = useState<string>('');
    const [successResult, setSuccess] = useState<boolean>(false);

    const handleResetFormSubmit = async (values: IResetPasswordInputs) => {
        try {
            const err = await resetPasswordCall(values);
            setError(err);
            if (err === '') setSuccess(true);
        } catch {
            setError('An error occurred. Please try again.');
        }
    };

    useEffect(() => {
        saveVisit('reset-password ResetCode: ' + ResetCode);
    }, [ResetCode]);

    if (successResult) {
        return (
            <div className="page-center">
                <h1>Password reset</h1>
                <p>Your password has been reset successfully. You can now sign in.</p>
                <a href="/" className="btn btn-primary">Go to home</a>
            </div>
        );
    }

    if (!ResetCodeValid) {
        return (
            <div className="page-center">
                <h1>Invalid reset link</h1>
                <p>This link has expired or is invalid. Please request a new password reset.</p>
            </div>
        );
    }

    return (
        <div className="reset-page">
            <div className="reset-card">
                <h1>Set new password</h1>
                <p className="sub">Enter a new password for your account.</p>
                <Form
                    initialValues={{ code: ResetCode }}
                    onSubmit={handleResetFormSubmit}
                    validate={validateResetPasswordForm}
                    render={({ handleSubmit, submitting, invalid, pristine }) => (
                        <form onSubmit={handleSubmit}>
                            <Field name="code" type="hidden" component="input" />
                            {errorConnection && <p className="dcr-error">{errorConnection}</p>}
                            <div className="dcr-field">
                                <label>New password</label>
                                <Field
                                    name="password"
                                    component={TextInput as React.ComponentType<FieldRenderProps<string, HTMLElement, string>>}
                                    type="password"
                                    placeholder="••••••••"
                                />
                            </div>
                            <button type="submit" disabled={submitting || invalid || pristine} className="dcr-btn dcr-btn-primary" style={{ width: '100%' }}>
                                Set new password
                            </button>
                        </form>
                    )}
                />
            </div>
        </div>
    );
};

export default ResetPassword;
